var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes},[_c('div',[(!_vm.locked)?_c('v-icon',{staticClass:"side-filter-icon",attrs:{"large":""},on:{"click":_vm.changeState}},[_vm._v(" mdi-arrow-collapse-left ")]):_vm._e(),_c('span',{staticClass:"side-filter-text"},[_vm._v(_vm._s(_vm.label))])],1),(_vm.isActive || _vm.locked)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }